module.exports = [
  'blues',
  'country',
  'easy listening',
  'electronic',
  'folk',
  'rap',
  'hip hop',
  'jazz',
  'latin',
  'pop',
  'r&b',
  'soul',
  'rock',
  'classical',
  'punk',
  'opera',
  'funk',
  'reggae',
  'heavy metal',
  'disco',
  'instrumental',
  'techno',
  'dance',
  'religious',
  'world',
  'gospel',
  'musical theatre',
  'hip hop',
  'singing blues',
  'rhythm and blues',
  'orchestra'
];